/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HTMLReactParser from "html-react-parser";
import './index.css';

function WhyPageAngelAi({angelAiLink}) {
    const imgCDNURL = process.env.REACT_APP_CDN_URL + "eaimortgage/images/";

    const listItems = [
        "Innovative Ai Technology Available 24/7",
        "Competitive Rates and Terms",
        "Affordable Down Payments",
        "In-House Nationwide Down Payment Assistance (DPA) Program",
        "Fast Turn-Times",
        "A TRU Approval<sup>®</sup> so you can search confidently",
        "Dedicated and experienced loan officers",
        "In-House Servicing on the majority of loans"
    ];

    return (
        <section className="WhyPageAngelAi-section">
            <div className="WhyPageAngelAi-bg"></div>
            <Container>
                <h1 className="WhyPageAngelAi-heading">What You Can Expect</h1>
                <Row className="WhyPageAngelAi-row">
                    <Col lg={7} md={12} sm={12} className="WhyPageAngelAi-column">
                        <ul className="WhyPageAngelAi-ul">
                            {listItems.map((item, index) => (
                                <li key={index}>{HTMLReactParser(item)}</li>
                            ))}
                        </ul>
                        <p className="WhyPageAngelAi-para">
                            {HTMLReactParser(angelAiLink)} is available when you need her, 24/7 to answer questions big and small and keep you updated on your loan status every step of the way. When you want the human touch, your EvolutionAI loan officer is always available to help.
                        </p>
                    </Col>
                    <Col lg={5} md={12} sm={12} className="WhyPageAngelAi-column-img">
                        <img
                            src={`${imgCDNURL}angelai-bot.gif`}
                            alt="AngelAi"
                            className="WhyPageAngelAi-gif"
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default WhyPageAngelAi;
